import { useState } from "react";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Terminal, ChevronDown, ChevronUp, X } from "lucide-react";
import { timeAgo } from "@/lib/lifeos";

const levelColor = { success: "#36f08a", info: "#00f0ff", warn: "#ffb454", error: "#ff3b30" };

function Row({ e }) {
  const c = levelColor[e.level] || "#00f0ff";
  return (
    <div className="flex items-start gap-2 py-1.5 px-2 hover:bg-white/[0.03] rounded font-mono text-[11px] anim-slidein">
      <span className="mt-0.5 w-1.5 h-1.5 rounded-full shrink-0" style={{ background: c, boxShadow: `0 0 6px ${c}` }} />
      {e.department_code && <span className="shrink-0" style={{ color: c }}>[{e.department_code}]</span>}
      <span className="text-zinc-300 flex-1 leading-snug">{e.message}</span>
      <span className="text-zinc-600 shrink-0">{timeAgo(e.created_at)}</span>
    </div>
  );
}

export default function ActivityFeed({ feed, floating, full, onClose }) {
  const [open, setOpen] = useState(true);
  const items = [...feed].reverse();

  if (full) {
    return (
      <div className="max-w-3xl mx-auto pt-8 px-4 pb-24">
        <div className="flex items-center justify-between mb-4">
          <h2 className="font-display uppercase tracking-widest text-cyan-300 text-lg flex items-center gap-2"><Terminal size={18} /> Tactical Activity Log</h2>
          <button data-testid="logs-close-button" onClick={onClose} className="w-8 h-8 grid place-items-center rounded-lg bg-white/5 hover:bg-white/10 text-zinc-400"><X size={16} /></button>
        </div>
        <div data-testid="activity-feed-panel" className="rounded-xl border border-white/10 bg-[#080b11]/80 p-2">
          <ScrollArea className="h-[70vh]">
            {items.length ? items.map((e, i) => <Row key={e.id || i} e={e} />) : <div className="text-zinc-600 text-sm font-mono p-6 text-center">No activity yet. Deploy an agent.</div>}
          </ScrollArea>
        </div>
      </div>
    );
  }

  // floating mini feed
  return (
    <div data-testid="activity-feed-floating" className="hidden md:block absolute bottom-4 left-4 z-20 w-80">
      <div className="backdrop-blur-xl bg-[#0b0e14]/90 border border-white/10 rounded-xl overflow-hidden shadow-xl">
        <button onClick={() => setOpen(!open)} className="w-full flex items-center gap-2 px-3 py-2 border-b border-white/5">
          <Terminal size={14} className="text-cyan-400" />
          <span className="font-tactical font-bold uppercase tracking-wider text-xs text-zinc-300">Live Activity</span>
          <span className="ml-auto flex items-center gap-1 text-[10px] font-mono text-emerald-400">
            <span className="w-1.5 h-1.5 rounded-full bg-emerald-400 anim-flicker" /> LIVE
          </span>
          {open ? <ChevronDown size={14} className="text-zinc-500" /> : <ChevronUp size={14} className="text-zinc-500" />}
        </button>
        {open && (
          <div className="max-h-56 overflow-y-auto thin-scroll p-1">
            {items.length ? items.slice(0, 30).map((e, i) => <Row key={e.id || i} e={e} />) : <div className="text-zinc-600 text-[11px] font-mono p-4 text-center">Awaiting agent activity...</div>}
          </div>
        )}
      </div>
    </div>
  );
}
